<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation per mobile -->
<ng-container *ngIf="isScreenSmall">
    <fuse-vertical-navigation class="bg-card text-primary print:hidden w-full" [mode]="'over'" [name]="'mainNavigation'"
        [navigation]="navMenu" [opened]="false">
        <ng-container fuseVerticalNavigationContentHeader>
            <demo-logo-comune></demo-logo-comune>
        </ng-container>
    </fuse-vertical-navigation>
</ng-container>


<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0"  #page>

    <!-- Primo Header -->
    <div class="flex flex-0 content-center justify-between items-center w-full h-12 sm:h-12 xl:px-80 md:px-20 sm:px-3 z-49 shadow dark:shadow-none dark:border-b bg-[#002e57] dark:bg-transparent print:hidden"  id="top">
        <div>
            <a class="text-white text-md font-light font-sans hover:underline cursor-pointer"
                href="https://www.regione.liguria.it/">Regione Liguria xxxxxxxxxxxxxxxxxxxxx</a>
        </div>
        <user></user>
    </div>

    <!-- Secondo Header -->
    <div
        class="flex flex-0 content-center justify-between items-center w-full h-30 md:h-30 sm:h-20 xl:px-80 md:px-24 sm:px-3 z-49 shadow dark:shadow-none bg-primary dark:bg-transparent print:hidden">

        <!-- Navigation toggle button per mobile-->
        <ng-container *ngIf="isScreenSmall">
            <button mat-icon-button (click)="toggleNavigation('mainNavigation')" aria-pressed="false">
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
        </ng-container>

        <!-- Components -->
        <demo-logo-comune></demo-logo-comune>

        <demo-social-links [data]="true"></demo-social-links>

    </div>

    <ng-container *ngIf="!isScreenSmall">
        <!-- Horizontal navigation non mobile -->
        <fuse-horizontal-navigation
            class="flex flex-row justify-around w-full h-15 text-3xl font-semibold text-white shadow dark:shadow-none dark:border-b bg-primary dark:bg-transparent print:hidden"
            [name]="'mainNavigation'" [navigation]="navMenu">
        </fuse-horizontal-navigation>
    </ng-container>

    <!-- Content -->
    <div class="flex flex-col min-w-0 h-max-full bg-card" >
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <app-breadcrumb></app-breadcrumb>


        <router-outlet *ngIf="true"></router-outlet>

    </div>


    <div *ngIf="(istanza?.numero_protocollo &&  !istanza?.stars) || !istanza" class="flex w-full h-full place-content-center bg-primary">
            <div class="my-10">
                <app-stepper-rating ></app-stepper-rating>
            </div>
    </div>


    <footer class="flex flex-col w-full  xl:px-80 md:px-20 sm:px-20 z-49 py-15  bg-[#001629]">

    <div [ngClass]="{'hidden': !scrolled}">
        <button  class="fixed bottom-7 right-7 rounded-full ring-1 ring-slate-100 bg-[#E74D3F] w-13 h-13 focus:ring-4 focus:ring-amber-700" (click)="scrollToAnchor('top')">
            <mat-icon class="icon-size-5 text-white" [svgIcon]="'heroicons_outline:arrow-up'"></mat-icon>
        </button>
    </div>

        <!-- Footer -->

            <!-- Grid -->
            <div class="flex md:flex-row sm:flex-col justify-start  gap-10 mb-10">

                <div class="flex flex-row md:h-18 text-white">
                    <img src="assets/images/logo-eu-inverted.svg" alt="Finanziato dall'Unione Europea - Next Generation EU">
                </div>

                <div class="flex flex-row md:h-18 text-white items-center content-center">
                    <img class="dark:hidden w-20 h-20 rounded-full" src="assets/images/spezia/logo.png" alt="Logo Comune della Spezia">
                    <a class="text-white ml-2 hover:underline cursor-pointer" href="https://www.comune.laspezia.it/">
                        <div class="flex flex-col">
                            <div class="text-white font-semibold md:text-4xl sm:text-xl">xxxxxxxx</div>
                            <div class="text-white text-base">xxxxxxxxxxxxxx</div>
                        </div>
                    </a>
                </div>

            </div>


            <demo-footer-menu [data]="dataMenu?.footer"></demo-footer-menu>
            <demo-footer-columns [data]="dataMenu?.footer_columns"></demo-footer-columns>

    </footer>

    <demo-footer-links [data]="dataMenu?.footer_links"></demo-footer-links>

</div>

